import { H } from "@jfrk/react-heading-levels";
import clsx from "clsx";
import PropTypes from "prop-types";
import React, { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";

import AptusContext from "../contexts/aptusContext";

import Bookable from "./Bookable";
import * as defaultStyles from "./Calendar.module.css";

Calendar.propTypes = {
  styles: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.string,
  title: PropTypes.string,
  groupId: PropTypes.number.isRequired,
};

export default function Calendar({
  styles = defaultStyles,
  className,
  title = "Upcoming days",
  groupId,
  ...restProps
}) {
  const { t } = useTranslation();
  const { calendar } = useContext(AptusContext);

  const weeks = useMemo(() => {
    return calendar?.find((item) => item.groupId == groupId)?.weeks;
  }, [calendar, groupId]);

  if (!weeks) {
    return null;
  }

  const weekdays = (week) => {
    // Always iterate over all 7 days of the week and output empty state for unavailable days
    return Array(7)
      .fill(0)
      .map((_, index) => {
        const day = week.dates.find((day) => day.weekDay === index + 1);
        if (!day) {
          return <div key={index} className={clsx(styles.empty)} />;
        }
        return <Bookable key={index} day={day} />;
      });
  };

  return (
    <div className={clsx(styles.component, className)} {...restProps}>
      <H className={clsx(styles.title)}>{title}</H>
      <div className={clsx(styles.days, className)}>
        <div className={clsx(styles.daysItem, className)}>M</div>
        <div className={clsx(styles.daysItem, className)}>T</div>
        <div className={clsx(styles.daysItem, className)}>O</div>
        <div className={clsx(styles.daysItem, className)}>T</div>
        <div className={clsx(styles.daysItem, className)}>F</div>
        <div className={clsx(styles.daysItem, className)}>L</div>
        <div className={clsx(styles.daysItem, className)}>S</div>
      </div>
      <div className={clsx(styles.weeks, className)}>
        {weeks.map((week, index) => (
          <div className={clsx(styles.week, className)} key={index}>
            <H className={clsx(styles.weekTitle)}>
              {t("week")} {week.weekNumber}
            </H>
            <div className={clsx(styles.dates, className)}>
              {weekdays(week)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
